const LISTAR_EQUIPES = (state, payload) => {
  state.items = payload
}

const BUSCANDO = (state, payload) => {
  state.buscando = payload
}

const INSERIR_EQUIPES = (state,  payload) => {
  state.items.push(payload)
}

const ATUALIZAR_EQUIPES = (state, payload) => {
  state.items = state.items.map(item => {
    if(item.id === payload.id) {
      return payload;
    }
    return item;
  })
}

const INSERIR_LISTA_TAREFAS = (state, payload) => {
  state.tarefas = payload
}

const INSERIR_LISTA_TODAS_TAREFAS = (state, payload) => {
  state.todasTarefas = payload
}

const ATUALIZAR_PAGINACAO = (state, payload) => {
  state.paginacao = payload
}

const INSERIR_LISTA_USUARIOS = (state, payload) => {
  state.usuarios = payload
}

const INSERIR_EQUIPE_SELECIONADA = (state, payload) => {
  state.selecionado = payload
}

export {
  LISTAR_EQUIPES,
  BUSCANDO,
  INSERIR_EQUIPES,
  ATUALIZAR_EQUIPES,
  ATUALIZAR_PAGINACAO,
  INSERIR_LISTA_USUARIOS,
  INSERIR_EQUIPE_SELECIONADA,
  INSERIR_LISTA_TAREFAS,
  INSERIR_LISTA_TODAS_TAREFAS
}